import { render, staticRenderFns } from "./TicketDetailCardAssignees.vue?vue&type=template&id=3ba5b3b2&"
import script from "./TicketDetailCardAssignees.vue?vue&type=script&lang=ts&"
export * from "./TicketDetailCardAssignees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VAvatar,VBadge})
